export enum ProjectViewMode {
    Edit = 'edit',
    Test = 'test'
}